import React, { useState } from "react";
import PageLayout from "../../components/PageLayout";
import "./style.scss";
import { Link } from "react-router-dom";

export default function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission (e.g., API call)
    setTimeout(() => {
      setIsSubmitting(false);
      alert("Form submitted successfully!");
    }, 2000); // Simulate a delay for submission
  };

  return (
    <PageLayout>
      <div className="container">
        <div className="middle-center">
          <h2 className="titletwo">
            <span>Contact</span> Us
          </h2>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="contacttopleft">
              <div className="inputbox">
                <input
                  type="text"
                  className="contact-input"
                  placeholder="Enter Name"
                  required
                />
              </div>
              <div className="inputbox">
                <input
                  type="email"
                  className="contact-input"
                  placeholder="Enter Email"
                  required
                />
              </div>
            </div>
            <div className="inputbox">
              <textarea
                className="contact-input"
                placeholder="Add Message"
                required
              />
            </div>
            <button type="submit" className="btn" disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </form>

          {/* <h5 className="titlefive">
            Mail us on{" "}
            <Link to="mailto:info@getpaths.com">info@getpaths.com</Link>
          </h5> */}
        </div>
      </div>
    </PageLayout>
  );
}
